function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.143 14.667a6.667 6.667 0 100-13.334 6.667 6.667 0 000 13.334zM11.28 6.47l-.943-.942L6.81 9.057l-.862-.862-.943.943 1.805 1.805 4.47-4.472z",
  fill: "#0C9846"
});

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlN1Y2Nlc3MiPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMTQyODYgMTQuNjY2NkMxMS44MjQ4IDE0LjY2NjYgMTQuODA5NSAxMS42ODE4IDE0LjgwOTUgNy45OTk5MkMxNC44MDk1IDQuMzE4MDIgMTEuODI0OCAxLjMzMzI1IDguMTQyODYgMS4zMzMyNUM0LjQ2MDk2IDEuMzMzMjUgMS40NzYyIDQuMzE4MDIgMS40NzYyIDcuOTk5OTJDMS40NzYyIDExLjY4MTggNC40NjA5NiAxNC42NjY2IDguMTQyODYgMTQuNjY2NlpNMTEuMjgwOSA2LjQ3MTMyTDEwLjMzODEgNS41Mjg1MUw2LjgwOTUzIDkuMDU3MTFMNS45NDc2IDguMTk1MThMNS4wMDQ3OSA5LjEzNzk5TDYuODA5NTMgMTAuOTQyN0wxMS4yODA5IDYuNDcxMzJaIiBmaWxsPSIjMEM5ODQ2Ii8+CjwvZz4KPC9zdmc+Cg==";
export { SvgSuccess as ReactComponent };